// removed by extract-text-webpack-plugin
module.exports = {"base":"_3_Opx","label":"_3eim0","filter":"_31L1X","clear":"_19oeT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/List/components/Filters/Filters.scss
// module id = 2566
// module chunks = 0